// extracted by mini-css-extract-plugin
export default {"footer":"quvHz8ib22oiGBChMVv6","mobile":"AXgElNttwg_K9FCFTFNG","container":"fnNxGIpNC3sdLerCwAGd","swapDescription":"MJmAFnueacnjUZIRXzKS","serviceLinks":"g6rdUycevW1afh4TfIAo"};